import { typesColors } from "constants/colors";
import React, { useMemo } from "react";
import { Box, HStack, Tag, TagLabel } from "@chakra-ui/react";
import { LeadTypeEnum } from "enums/lead-type.enum";
import { getLeadTypeLabel } from "utils/lead-type.utils";
import { LeadSourceEnum } from "enums/lead-source.enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react";
import { useAppStore } from "utils/react-hooks/useAppStore.hook";
import { LEAD_ICON_MAP, getLeadIcon } from "constants/lead-icons";

interface ILeadTypeTagProps {
  type: LeadTypeEnum;
  source?: LeadSourceEnum;
}

export const LeadTypeTag: React.FC<ILeadTypeTagProps> = observer(
  ({ type, source }) => {
    const {
      userAccountsStore: { selectedAccountStore },
    } = useAppStore();

    const configMap =
      selectedAccountStore?.accountLeadIconsStore.leadIconConfigMap;

    const sourceBanner = useMemo(() => {
      if (!source || !configMap) return null;
      const icon = getLeadIcon(configMap, source, type);
      if (!icon) return null;
      const glyph = LEAD_ICON_MAP[icon];
      if (!glyph) return null;
      return (
        <Box
          display="flex"
          alignItems="center"
          mr={2}
          overflow="hidden"
          justifyContent="center"
        >
          <Box color={glyph.color}>
            <FontAwesomeIcon icon={glyph.icon} fontSize="21px" />
          </Box>
        </Box>
      );
    }, [configMap, source, type]);

    return (
      <HStack>
        <Tag
          variant={"subtle"}
          textTransform="capitalize"
          border={"1px solid"}
          borderColor={typesColors[type]?.statsColor}
          colorScheme={typesColors[type]?.colorScheme}
          p={0}
          minWidth={"114px"}
        >
          <TagLabel
            m={1}
            px={5}
            lineHeight={1.5}
            bg={"white"}
            color={"leadpro.500"}
            width={"100%"}
            height={"100%"}
            textAlign={"center"}
          >
            {getLeadTypeLabel(type)}
          </TagLabel>
        </Tag>
        {sourceBanner}
      </HStack>
    );
  }
);
